import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import { ERROR_TYPE, getAllErrors, renderErrorMessages } from "@/utils";

import { missingColumnsOfRequestError } from "../utils/missingColumnsOfRequestError";

interface TestSendErrorsProps {
	error: FetchBaseQueryError | SerializedError | undefined;
	formErrors: ERROR_TYPE[];
}

/**
 * The errors under a test-send form. A send refused because the lead has no value for a column
 * names the columns, as a failed campaign step does (PREC-4440); every other error keeps the
 * generic rendering, which knows only fixed codes.
 */
export const TestSendErrors: FunctionComponent<TestSendErrorsProps> = ({ error, formErrors }) => {
	const { t } = useTranslation();
	const missingColumns = missingColumnsOfRequestError(error);

	if (missingColumns) {
		return (
			<div
				className="rounded-md bg-status-error-light px-3 py-2 text-sm text-status-error"
				data-testid="test-send-missing-column"
				role="alert"
			>
				{t("outbox.failure.MISSING_COLUMN_VALUE.testSend", { columns: missingColumns.join(", ") })}
			</div>
		);
	}

	const errors = getAllErrors(error, formErrors);

	return errors.length ? <div>{renderErrorMessages(errors)}</div> : null;
};
